import { toast } from 'sonner';
import { apiService } from '../../utils/api';

const getEmployees = async () => await apiService.get(`/api/v1/employee/left-panel`);
export const geCompanyDetail = async (id) => await apiService.get(`/api/v1/company/${id}/`);

/**
 * Lightweight app-wide load of the company detail (e.g. `solution_approval_required`
 * gating ApprovalItemActions). No-op when already loaded/loading; unlike
 * loadCompanyDetail it does not fetch the employee list.
 */
export const ensureCompanyDetail = () => async (dispatch, getState) => {
  const { company, auth } = getState();
  const companyId = auth.current_company;
  if (String(company.detail?.id) === String(companyId) || company.loading || !companyId) return;
  dispatch({ type: 'START_LOADING_COMPANY' });
  try {
    const { data } = await geCompanyDetail(companyId);
    if (String(getState().auth.current_company) !== String(companyId)) return;
    dispatch({ type: 'COMPANY_LOADED_SUCCESSFULL', data });
  } catch (err) {
    if (String(getState().auth.current_company) === String(companyId)) {
      dispatch({ type: 'COMPANY_LOAD_FAILED' });
    }
    console.error(err);
  }
};

export const loadCompanyDetail = () => async (dispatch, getState) => {
  dispatch({ type: 'START_LOADING_COMPANY' });

  try {
    const [{ data: employees }, { data: comDetail }] = await Promise.all([
      getEmployees(),
      geCompanyDetail(getState().auth.current_company),
    ]);

    if (employees && comDetail) {
      dispatch({ type: 'COMPANY_LOADED_SUCCESSFULL', data: comDetail });
      dispatch({
        type: 'EMPLOYEES_LOADED_SUCSESSFULL',
        data: employees?.results,
      });
    }
  } catch (err) {
    console.log(err);
  }
};

export const editCompany = (values) => async (dispatch, getState) => {
  let status = null;
  let error = null;

  try {
    status = (await apiService.patch(`/api/v1/company/${getState().auth.current_company}/`, values))
      .status;
  } catch (err) {
    error = err;
  }
  return new Promise((resolve, _reject) => {
    if (status && status === 200) {
      dispatch({ type: 'COMPANY_EDITED_SUCCESSFULL', data: values });
      resolve({ status: true, error });
    }
    resolve({ status: false, error });
  });
};

export const updateMembers =
  (values, action = null) =>
  async (dispatch, getState) => {
    try {
      const { data } = await apiService.post(
        `/api/v1/company/${getState().auth.current_company}/${action !== null ? `${action}/` : ''}`,
        { administrators: [values] }
      );
      if (data) {
        dispatch({ type: 'UPDATE_ADMINISTRATORS_SUCCESSFULL', data });
      }
    } catch (_err) {
      //
    }
  };

const testConnectionDropBox = async (values) => {
  const { type } = values;
  let connectionStatus = false;
  const dataForSubmit = { ...values };
  delete dataForSubmit.type;
  try {
    const { data: status } = await apiService.post(
      '/api/v1/current-company/storage/check_connection/',
      {
        type,
        access_data: {
          ...dataForSubmit,
        },
      },
      { silentError: true }
    );
    if (status === true) {
      toast.success('Pripojeni ke sluzbe je validni');
      connectionStatus = true;
    }
  } catch (_e) {
    toast.error('Test propjení se nezdařil, zkontrolujte zadané údaje.');
  }
  return connectionStatus;
};

export const fetchStorageDetail = () => async (dispatch, _getState) => {
  try {
    const { data } = await apiService.get('/api/v1/current-company/storage/');
    if (data) {
      dispatch({ type: 'FETCH_STORAGE_SUCCESSFULL', data });
    }
  } catch (_e) {
    //
  }
};

export const updateStorage = (inputData) => async (dispatch, _getState) => {
  let status = null;
  let error = null;
  let values = null;
  try {
    const testConnectionStatus = await testConnectionDropBox(inputData);

    if (testConnectionStatus) {
      const { type } = inputData;
      delete inputData.type;
      const { data, status: responseStatus } = await apiService.patch(
        '/api/v1/current-company/storage/',
        { access_data: { ...inputData }, type }
      );
      if (data) {
        values = data;
        status = responseStatus;
      }
    }
  } catch (err) {
    error = err;
  }
  return new Promise((resolve, _reject) => {
    if (status && status === 200) {
      dispatch({ type: 'UPDATE_STORAGE_SUCCESSFULL', data: values });
      resolve({ status: true, error });
    }
    resolve({ status: false, error });
  });
};
